import React from 'react';
import { useSelector } from 'react-redux';
import './Infographic.scss';
import { useMediaQuery } from 'react-responsive';

import { useWindowSize, usePrevious } from '../../../models/Hooks';

import { ReactComponent as Logo } from '../../../assets/images/graphics/verizon.svg';
import { ReactComponent as Bar } from '../../../assets/images/graphics/icn_pbp-bar.svg';

const Infographic = ({ barCount, altText, active }) => {
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
    const win = useWindowSize();
    const maxBarVal = 5;
    const expandSpeed = 0.35;
    const barFillSpeed = 0.6;
    const prevBarCount = usePrevious(barCount);
    const menuOpened = useSelector(state => state.data.menuOpened);

    if(!win.width || !win.height){
        return null;
    }
    
    var logoRatio = 431/371;
    var barRatio = 432/219;
    var maxHeight = (isPortrait)?win.width/barRatio:Math.min(win.height * 0.4, 373);
    var logoWidth = maxHeight * (1/logoRatio);
    var barWidth = maxHeight * (1/barRatio);
    var barContainerWidth = (barWidth * 1.5);
    var infographicContainerWidth = logoWidth + barContainerWidth;
    
    var bars = [];
    for(var i = 0; i<maxBarVal; i++){
        var filled = (i+1) <= barCount;
        var offset = (barContainerWidth/5)*(maxBarVal - i - 1);
        var transitionDelay = ((barFillSpeed/maxBarVal)*((barCount > prevBarCount)?i:(maxBarVal - i)) + ((prevBarCount < 0)?expandSpeed:0)); //Staggered Offset with additional time added if it's the first time it's expanding
        bars.push(
            <div key={i} className="bar-wrapper" style={{width: barWidth, height: maxHeight, right: offset}}>
                <Bar className="bars" width={barWidth+"px"} height={maxHeight+"px"} fillOpacity={0.2} />
                <Bar className="bars" offset={"30%"} width={barWidth+"px"} height={maxHeight+"px"}
                    style={{
                        clip: "rect("+((filled)?0:maxHeight)+"px, "+barWidth+"px, "+maxHeight+"px, 0px)",
                        transitionDelay: transitionDelay+"s"
                    }} />
            </div>);
    }

    var maskPoints = logoWidth+",0 "+(logoWidth*0.43)+","+maxHeight+" -"+barContainerWidth+","+maxHeight+" -"+barContainerWidth+",0";

    return (
        <div  className="pulse-infographic">
            <div className="infographic-outer" style={{width: infographicContainerWidth, height: maxHeight }}>
                <div className="infographic-inner" style={{width: (barCount >= 0)?infographicContainerWidth:logoWidth, transition: "width "+expandSpeed+"s ease-in-out"}}>
                    <div className="logo-holder" style={{width: logoWidth}}  role="img" aria-label={`${altText} ${barCount >= 0 ? barCount + "bars": ''}`}>
                        <svg className="mask" width={logoWidth+"px"} height={maxHeight+"px"}>
                            <polygon points={maskPoints} fill="black" />
                        </svg>
                        <Logo className="logo" width={logoWidth+"px"} height={maxHeight+"px"} fill={"#b52b1e"}
                            />
                    </div>
                    <div className="bar-holder" style={{width: logoWidth}}>
                        {bars}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Infographic;
